import { render, staticRenderFns } from "./blocked_users.vue?vue&type=template&id=789caa8c&"
import script from "./blocked_users.vue?vue&type=script&lang=js&"
export * from "./blocked_users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports